export default {
  "about": {
    "careersDetails": {
      "anqing": "Anqing",
      "applyResume": "Postuler avec CV",
      "backToPrevious": "Retourner à la page précédente",
      "category": "Catégorie :",
      "education": "Niveau d'études minimum :",
      "errors": {
        "getInfoFailed": "Échec de récupération des informations",
        "getJobDetailFailed": "Échec de récupération des détails du poste",
        "getJobDetailFailedRetry": "Échec de récupération des détails du poste, veuillez réessayer plus tard",
        "jobNotExist": "Les informations sur le poste n'existent pas",
        "parseInfoFailed": "Échec d'analyse des informations"
      },
      "jobDescription": "Description du poste",
      "jobRequirements": "Exigences du poste",
      "nationwide": "Tout le pays",
      "noJobInfo": "Les informations sur le poste n'existent pas",
      "person": "personne(s)",
      "recruitmentCount": "Nombre de recrutements :",
      "salary": "Conditions de rémunération :",
      "suzhou": "Suzhou",
      "workLocation": "Lieu de travail :",
      "workYear": "Années d'expérience :",
    },
    "contact": {
      "address": "Adresse :",
      "contactInfo": "Coordonnées",
      "email": "Email :",
      "errors": {
        "getContactFailed": "Échec de récupération des données de coordonnées"
      },
      "pageTitle": "Nous contacter",
      "phone": "Téléphone :",
      "postcode": "Code postal :",
    },
    "page": {
      "careers": {
        "activities": {
          "balance": {
            "description": "Promouvoir l'équilibre entre travail et vie privée",
            "subtitle": "KEEP BALANCED",
            "title": "Équilibre et progrès"
          },
          "learning": {
            "description": "Créer une organisation d'apprentissage et promouvoir l'apprentissage tout au long de la vie",
            "subtitle": "KEEP LEARNING",
            "title": "Apprentissage infini"
          }
        },
        "category": "Catégorie :",
        "errors": {
          "getAreaFailed": "Échec de récupération des lieux de travail",
          "getAreaFailedRetry": "Échec de récupération des lieux de travail, veuillez réessayer plus tard",
          "getCategoryFailed": "Échec de récupération des catégories de postes",
          "getCategoryFailedRetry": "Échec de récupération des catégories de postes, veuillez réessayer plus tard",
          "getJobsFailed": "Échec de récupération de la liste des postes",
          "getJobsFailedRetry": "Échec de récupération de la liste des postes, veuillez réessayer plus tard",
          "getNatureFailed": "Échec de récupération de la nature du travail",
          "getNatureFailedRetry": "Échec de récupération de la nature du travail, veuillez réessayer plus tard"
        },
        "jobCategory": "Catégorie de poste",
        "jobNature": "Nature du travail",
        "nationwide": "Tout le pays",
        "noData": "Aucune donnée disponible",
        "noJobs": "Aucun poste pertinent disponible",
        "publishDate": "Date de publication",
        "searchBox": {
          "campusRecruitment": "Recrutement campus",
          "placeholder": "Veuillez entrer un mot-clé",
          "search": "Rechercher",
          "socialRecruitment": "Recrutement social"
        },
        "viewDetail": "Voir les détails >",
        "workLocation": "Lieu de travail"
      },
      "company": {
        "companyIntro": "Fondée en 2003 avec son siège social à Suzhou en Chine, après des années de développement innovant, elle est devenue une entreprise nationale de haute technologie intégrant la R&D, la production, les ventes et le service. Son champ d'activité couvre les sciences de la vie, les soins personnels, les nouveaux matériaux, la sélection de produits de recherche, les tests, etc.",
        "companyName": "Yacoo Science",
        "dataSection": {
          "founded": "Fondée en",
          "globalCustomers": "Clients mondiaux",
          "globalPartners": "Partenaires écologiques mondiaux",
          "patents": "Brevets déposés à l'intérieur et à l'extérieur du pays",
          "productionBase": "Capacité de production annuelle",
          "salesCountries": "Pays et régions de vente",
          "title": "Données de l'entreprise",
          "unit": "tonne(s)",
          "year": "année(s)"
        },
        "history": {
          "title": "Histoire de développement"
        },
        "honor": {
          "title": "Honoraires et certifications"
        },
        "pageTitle": "Présentation de l'entreprise",
        "subtitle": "Yacoo Science est le leader innovant des matériaux médico-chimiques mondiaux.",
        "vision": {
          "mission": {
            "description": "S'engager à promouvoir le progrès technique et l'innovation des matériaux médico-chimiques",
            "title": "Mission"
          },
          "title": "Philosophie de l'entreprise",
          "values": {
            "description": "Intégrité et gratitude, responsabilité et diligence, pragmatisme et lutte, innovation et excellence",
            "title": "Valeurs fondamentales"
          },
          "vision": {
            "description": "Devenir un leader innovant mondial dans les matériaux médico-chimiques",
            "title": "Vision"
          }
        }
      },
      "production": {
        "intro": "Yacoo Science dispose d'une capacité de fabrication stable et fiable. À l'heure actuelle, elle a construit deux bases de production à Jining et Anqing, équipées d'équipements et de procédés de production de pointe internationale, se concentrant sur la R-D et la production de produits chimiques fins de haute qualité. La capacité de production totale de chaque base dépasse 100 000 tonnes par an, et elle a obtenu la certification du système de management de la qualité ISO 9001, du système de management environnemental ISO 14001 et du système de management de la sécurité et de la santé au travail ISO 45001.",
        "intro2": "Yacoo Science assure que chaque lot de produits répond aux normes élevées de l'industrie grâce à son système de contrôle de qualité « zéro défaut », et fournit en permanence aux clients mondiaux des solutions de supply fiables et stables de produits chimiques. Sur la base de ses avantages compétitifs tels que la capacité de production à grande échelle, la production intelligente et le contrôle complet des matières premières, elle offre aux industries émergentes stratégiques telles que la santé médicale et la biotechnologie une « solution globale de matières premières allant de la recherche scientifique à la production commerciale », aidant les clients à réaliser un développement stable.",
        "siteInfo": {
          "area": "Surface occupée :",
          "capacity": "Ateliers et capacité de production :",
          "coreProducts": "Produits de base :",
          "field": "Domaine d'application :",
        },
        "title": "Bases de production"
      },
      "quality": {
        "equipment": {
          "description": "En établissant une plateforme complète d'instruments de test, incluant le chromatographe liquide à haute performance (HPLC), le chromatographe en phase gazeuse (GC), le spectromètre de résonance magnétique nucléaire (RMN), le polarimètre, le spectromètre infrarouge (IR), le spectromètre d'émission à plasma à couplage inductif (ICP-OES), le titrimètre automatique potentiométrique et le tensiomètre à Karl Fischer par méthode de Coulomb, Yacoo Science peut répondre aux besoins de test de libération à haute précision et à haute complexité des clients dans diverses scénarios d'impact.",
          "devices": {
            "automaticTitrator": "Titrimètre automatique potentiométrique",
            "broadbandNMR": "Spectromètre de résonance magnétique nucléaire à bobines multiples à large bande",
            "gcms": "GC-MS (Chromatographie en phase gazeuse couplée à la spectrométrie de masse)",
            "icpSpectrometer": "Spectromètre d'émission à plasma à couplage inductif (ICP-OES)",
            "infraredSpectrometer": "Spectromètre infrarouge (IR)",
            "karlFischer": "Tensiomètre à Karl Fischer par méthode de Coulomb"
          },
          "title": "Equipements de test"
        },
        "intro": "Yacoo Science garantit la qualité des produits par le contrôle du processus, se concentrant sur la fourniture à ses clients de divers produits à meilleur rapport qualité-prix et de services plus de qualité, avec pour mission de soutenir l'innovation des clients. Sur la base de 22 ans d'expérience accumulée dans le test de matériaux médico-chimiques, une équipe de recherche et d'analyse menée par plusieurs docteurs offre aux clients une solution globale allant du test à l'optimisation technique.",
        "intro2": "La plateforme de test de Yacoo Science dispose d'un laboratoire moderne de 3 000 m², avec un système de circulation et de purification de l'air líder sur le marché chinois, garantissant un environnement de test sûr et contrôlé. La plateforme est équipée d'un espace d'analyse chimique complet et d'un ensemble d'instruments haut de gamme, répondant aux besoins de test à haute précision et à haute complexité. Conformément aux lois, règlements et normes techniques de divers pays/régions (tels que REACH de l'UE, FDA des États-Unis, CDE de la Chine), elle aide les clients à éviter les barrières commerciales et à réaliser la gestion de conformité du cycle de vie complet des produits.",
        "navigation": {
          "next": "Suivant",
          "prev": "Précédent"
        },
        "system": {
          "description": "Yacoo Science a établi un système complet de test de matériaux médico-chimiques couvrant la caractérisation structurale, les propriétés physico-chimiques, l'analyse d'éléments, l'analyse de spectres, l'étude de stabilité, l'intégrité et la traçabilité des données, l'étude d'analyse d'impuretés et le test de matières premières et auxiliaires. Son management de la qualité a obtenu la certification du système GMP et du système de management de la qualité ISO 9001:2015, soutenant le développement et l'application des clients sur le marché mondial.",
          "title": "Système de test"
        },
        "title": "Management de la qualité"
      }
    },
    "tabs": {
      "careers": "Rejoignez-nous",
      "company": "Présentation de l'entreprise",
      "production": "Bases de production",
      "quality": "Management de la qualité"
    }
  },
  "dzhc": {
    "businessIntroText": "Le service sur mesure est l'activité centrale de Yacoo Science Fondée sur 22 ans d'expérience accumulée dans la R-D de matériaux médico-chimiques, Yacoo Science peut offrir aux clients un service sur mesure global stable et fiable. Nous disposons d'une équipe de R-D et d'une équipe de contrôle qualité composée de scientifiques et d'ingénieurs expérimentés, avons établi cinq plateformes expérimentales telles que la plateforme de synthèse intelligente AI, la plateforme de synthèse chimique et la plateforme de synthèse biologique, et sommes équipés de plateformes de test avancées telles que le chromatographe liquide à haute performance, le chromatographe en phase gazeuse et le polarimètre. De plus, Yacoo Science dispose de deux bases de production avec une capacité annuelle de plus de 100 000 tonnes chacune, capable de répondre aux besoins complets des clients dans le domaine des matériaux médico-chimiques, depuis la synthèse sur mesure, le service CRO jusqu'au service CDMO.",
    "businessIntroTitle": "Présentation de l'activité",
    "businessItems": ["Matériaux polymères", "Monomères polymériques", "Intermédiaires pharmaceutiques", "Nouveaux matériaux électrochimiques", "Matériaux bruts pour tests cliniques"],
    "caseTabs": [
      {
        "title": "Équipe d'experts dans le domaine médico-chimique",
        "description": "Composée de près de 100 scientifiques et ingénieurs expérimentés, avec plus de 40 % de talents titulaires de master ou de doctorat, plus de 150 brevets de R-D déposés et plus de 50 approuvés."
      },
      {
        "title": "Plateforme de R-D et de test de premier ordre",
        "description": "Établissement de cinq plateformes expérimentales telles que la plateforme de synthèse intelligente AI, la plateforme de synthèse chimique et la plateforme de synthèse biologique, équipées de plateformes de test avancées telles que le chromatographe liquide à haute performance, le chromatographe en phase gazeuse et le polarimètre."
      },
      {
        "title": "Garantie du système de qualité international",
        "description": "Respect strict des normes internationales ISO, contrôle de qualité sur l'ensemble du processus, garantissant une haute fiabilité des produits. Contrôle de qualité à multiple niveaux, du tri des matières premières au produit fini."
      }
    ],
    "coreBusinessTitle": "Activité de base",
    "featureTitle": "Caractéristiques du service",
    "pageSubtitle": "Service de personnalisation CRO+CDMO pour produits médico-chimiques",
    "pageTitle": "Service sur mesure",
    "processItems": [
      {
        "title": "Conception de route",
        "desc": ["Plus de 100 chercheurs expérimentés", "Conception de route de synthèse assistée par AI"]
      },
      {
        "title": "R-D et synthèse",
        "desc": ["Laboratoire de R-D de plus de 10 000 m²", "Couvrant 80 % des réactions courantes"]
      },
      {
        "title": "Production d'échantillons",
        "desc": ["Production dans des usines de plus de 200 000 m²", "Contrôle de qualité strict, garantie de qualité"]
      },
      {
        "title": "Conditionnement et envoi",
        "desc": ["Répondant aux exigences de conditionnement et d'envoi de solides/liquides divers", "Envoi d'échantillons professionnel/suivi logistique"]
      }
    ],
    "processTitle": "Processus de synthèse personnalisée",
    "startProject": "Démarrez immédiatement votre projet sur mesure",
    "startProjectDesc": "Exprimez vos besoins, notre équipe professionnelle vous offre un conseil technique individualisé et une solution sur mesure.",
    "viewMore": "Voir plus"
  },
  "header": {
    "contactUs": "Nous contacter",
    "menu": {
      "about": "À propos de Yacoo",
      "companyProfile": "Présentation de l'entreprise",
      "customSynthesis": "Service sur mesure",
      "greenEnergy": "Énergie verte",
      "innovation": "Résultats d'innovation",
      "joinUs": "Rejoignez-nous",
      "news": "Centre d'informations",
      "other": "Autres activités",
      "production": "Bases de production",
      "products": "Centre de produits",
      "quality": "Management de la qualité",
      "rAndDSystem": "Système de R-D",
      "researchPurchase": "Achat de recherche scientifique",
      "smartPlatform": "Plateforme intelligente",
      "solution": "Solutions sectorielles",
      "sustainability": "Développement durable",
      "technology": "R-D et innovation",
      "testingService": "Service de test"
    },
    "searchPlaceholder": "Veuillez entrer le contenu de recherche..."
  },
  "home": {
    "about": {
      "description": "Fondée en 2003 avec son siège social à Suzhou en Chine, après des années de développement innovant, elle est devenue une entreprise nationale de haute technologie intégrant la R&D, la production, les ventes et le service. Son champ d'activité couvre les sciences de la vie, les soins personnels, les nouveaux matériaux, la sélection de produits de recherche, les tests, etc.",
      "learnMore": "En savoir plus",
      "subtitle": "Yacoo Science est le leader innovant des matériaux médico-chimiques mondiaux.",
      "title": "À propos de Yacoo"
    },
    "globalService": {
      "description": "Yacoo Science peut offrir aux clients mondiaux un service CRO+CMO global allant de la synthèse sur mesure à la production à grande échelle, répondant à vos besoins en produits tout au long du processus de la recherche scientifique à la production commerciale.",
      "legend": {
        "customers": {
          "en": "Our Customers",
          "zh": "Clients servis"
        },
        "headquarters": {
          "en": "Yacoo Headquarter",
          "zh": "Siège social de Yacoo"
        },
        "subsidiaries": {
          "en": "Subsidiary Companies",
          "zh": "Filiales de Yacoo"
        }
      },
      "stats": {
        "title": "Layout international",
        "capacity": "Des filiales à l'étranger établies à Singapour, aux États-Unis et en Allemagne",
        "patents": "Plus de 15 000 clients dans le monde",
        "team": "Activité couvrant plus de 70 pays dans le monde"
      },
      "title": "Réseau de services mondiaux"
    },
    "news": {
      "searchBtn": "recherche",
      "filter": "Filtrer les nouvelles par catégorie",
      "noNews": "Aucune nouvelle pertinente disponible",
      "pageTitle": "Centre d'informations",
      "searchPlaceholder": "Veuillez entrer un mot-clé",
      "title": "Actualités de Yacoo",
      "topTag": "Mis en évidence",
      "viewDetail": "En savoir plus",
      "viewMore": "Voir plus"
    },
    "solutions": {
      "title": "Produits et solutions"
    }
  },
  "jcfw": {
    "actionBtn": "Consulter maintenant",
    "businessIntroText1": "Wonder Testing est une plateforme indépendante de services de test appartenant à Yacoo Science Fondée sur 22 ans d'expérience accumulée dans le test de matériaux médico-chimiques de Yacoo Science, Wonder Testing s'engage à construire une plateforme de services de qualité internationale, et offre aux entreprises manufacturières/entreprises de commerce nationales/étrangères des services de test, de certification et de conseil correspondant aux lois/règlements/normes techniques de divers pays/régions, sur la base de la certification CMA (Certification de métrologie chinoise) et de la reconnaissance de laboratoire CNAS (ISO/IEC 17025). Elle fournit aux clients une solution globale allant du test à l'optimisation technique.",
    "businessIntroText2": "La plateforme Wonder Testing dispose d'un laboratoire moderne de 3 000 m², avec un système de circulation et de purification de l'air líder sur le marché chinois, garantissant un environnement de test sûr et contrôlé. La plateforme est équipée d'un espace d'analyse chimique complet et d'un ensemble d'instruments haut de gamme, répondant aux besoins de test à haute précision et à haute complexité. Conformément aux lois, règlements et normes techniques de divers pays/régions (tels que REACH de l'UE, FDA des États-Unis, CDE de la Chine), elle aide les clients à éviter les barrières commerciales et à réaliser la gestion de conformité du cycle de vie complet des produits.",
    "businessIntroTitle": "Présentation de l'activité",
    "businessItems": ["Services de test et d'inspection", "Recherche médicale et développement expérimental", "Services de technologie de test", "Services de certification"],
    "businessItemsClass": ["Biens de consommation courante", "Produits électroniques et électriques", "Jouets et produits pour enfants", "Matériaux en contact avec les aliments", "Matériaux automobiles", "Biens de lumière et textiles"],
    "businessTip": "Le laboratoire a établi un système complet de services de test, capable de répondre aux besoins de test chimique et physique de biens de consommation courante, produits électroniques et électriques, jouets et produits pour enfants, matériaux en contact avec les aliments, matériaux automobiles, biens de lumière et textiles, etc.",
    "caseTabs": [
      {"title":"Expérience en test et certification de conformité","description":"S'appuyant sur 22 ans d'expérience de services de test dans le domaine médico-chimique de Yacoo Science, le laboratoire s'engage à fournir aux entreprises manufacturières et aux négociants du monde entier des services de test de conformité, de certification et de conseil technique."},
      {"title":"Certification du système de management selon les normes internationales","description":"Les indicateurs de test et le système de management répondent aux exigences du système de qualité international, et ont obtenu la reconnaissance de nombreux clients leaders internationaux, garantissant l'autorité et la crédibilité des données de test."},
      {"title":"Couverture complète des capacités de test","description":"Fournit des services complets dans les domaines du test chimique des biens de consommation, l'évaluation de la sécurité des jouets pour enfants, le test des textiles, le test de conformité des matériaux en contact avec les aliments et l'analyse des matériaux automobiles, aidant les entreprises à répondre aux exigences réglementaires des différents pays (telles que REACH, FDA, CDE, etc.)."}
    ],
    "contact": {
      "address": "Adresse : 8ème étage, 112 Rue Xinqing, Zone Industrielle de Suzhou, Suzhou",
      "email": "Email de contact : service@wondertesting.cn",
      "phone": "Téléphone : +86-18625246998",
      "postcode": "Code postal : 215121"
    },
    "contactTitle": "Nous contacter",
    "coreBusinessTitle": "Activité principale",
    "equipmentDesc": "En établissant une plateforme complète d'instruments de test, incluant le chromatographe liquide à haute performance, le chromatographe en phase gazeuse, le spectromètre de résonance magnétique nucléaire, le polarimètre, le spectromètre infrarouge, etc., Yacoo Science peut répondre aux besoins de test de libération à haute précision et à haute complexité des clients dans diverses situations.",
    "equipmentList": ["Spectromètre infrarouge", "Spectromètre de résonance magnétique nucléaire à multi-bobines à large bande", "Spectromètre d'émission plasma à couplage inductif", "Tensiomètre Karl Fischer par méthode de Coulomb", "GC-MS", "Titrimètre potentiométrique automatique"],
    "equipmentTitle": "Equipements de test",
    "featureTitle": "Caractéristiques du service",
    "nextBtn": "Suivant",
    "pageSubtitle": "Prestataire intégré de services de test indépendant à optimisation technique",
    "pageTitle": "Services de test",
    "platformDesc": "Prestataire intégré de services de test et de certification",
    "prevBtn": "Précédent",
    "shopSubtitle": "Prestataire intégré de services de test indépendant à optimisation technique",
    "shopTitle": "Wonder Testing",
    "viewMore": "Voir plus"
  },
  "kycg": {
    "actionBtn": "Obtenir une solution",
    "businessIntroText": "Element Mall (www.b2star.com) est une plateforme e-commerce professionnelle dédiée à l'achat intégral de produits de recherche scientifique, appartenant à Yacoo Science En intégrant les canaux de fournisseurs de marques de qualité nationale et internationale, elle propose des produits professionnels tels que des réactifs de recherche, des équipements de protection, des consommables biologiques et des équipements expérimentaux, et s'efforce de mieux répondre aux besoins diversifiés des clients dans les domaines de la recherche en sciences de la vie, de la biopharmacie et des nouveaux matériaux à l'intérieur et à l'extérieur du pays.",
    "businessIntroTitle": "Présentation de l'activité",
    "businessItems": [
      {"title":"Réactifs de recherche","desc":"Réactifs biologiques, réactifs chimiques, réactifs d'analyse, autres réactifs"},
      {"title":"Équipements de protection","desc":"Protection des mains, protection de la tête, protection du visage, autres protections"},
      {"title":"Consommables biologiques","desc":"Culture cellulaire, consommables médicaux, consommables de chromatographie, consommables de test, consommables de pipetage, consommables outils"},
      {"title":"Equipements expérimentaux","desc":"Instruments ordinaires, instruments de test, instruments de chromatographie, instruments spécialisés, équipements de sécurité"}
    ],
    "caseTabs": [
      {"title":"Réponse de livraison en 24h","description":"Expédition directe depuis plusieurs entrepôts, livraison rapide"},
      {"title":"Plus de 6 millions de spécifications de produits","description":"Nombreuses marques, gamme complète de catégories"},
      {"title":"Plus de 600 marques partenaires réputées","description":"Autorisation des fabricants, garantie de produits authentiques"},
      {"title":"Service d'achat attentionné","description":"Beaucoup d'avantages, service professionnel"}
    ],
    "contact": {
      "addressSuqian": "Adresse (Suqian) : 1er étage, Bâtiment Guke (A9), Parc d'e-commerce, District Suyu, Suqian",
      "addressSuzhou": "Adresse (Suzhou) : 112 Rue Xinqing, Zone Industrielle de Suzhou, Suzhou",
      "addressWuhan": "Adresse (Wuhan) : 11ème étage, No. 07, Bâtiment T3, Centre de Siège Guanggu, 766 Avenue Gaoxin, Zone de Développement Technologique Nouvelle du Lac Est, Wuhan",
      "addressChengdu": "Adresse (Chengdu) : Chambre 706, Bâtiment 3, Dingsheng International, 1ère Rue Wukeshi Ouest, District Wuhou, Chengdu",
      "email": "Email : sxg@b2star.com",
      "phone": "Téléphone : 15335295587"
    },
    "contactTitle": "Nous contacter",
    "coreBusinessTitle": "Activité principale",
    "enterShop": "Accéder à la commande",
    "featureTitle": "Caractéristiques du service",
    "pageSubtitle": "Plateforme intégrale d'achat pour la recherche scientifique",
    "pageTitle": "Achat de recherche scientifique",
    "shopBusiness": ["Réactifs de recherche", "Protection de sécurité", "Consommables biologiques", "Equipements expérimentaux"],
    "shopSubtitle": "Plateforme intégrale d'achat pour la recherche scientifique",
    "shopTitle": "Element Mall"
  },
  "lsny": {
    "actionBtn": "Obtenir un échantillon",
    "businessIntroText": "Goodenough New Energy (www.goodenoughchem.com) est une plateforme de services d'énergie verte appartenant à Yacoo Science Son agent de durcissement in situ ignifuge développé indépendamment améliore efficacement la sécurité des batteries et a obtenu la reconnaissance de collaboration de nombreuses entreprises leaders. En tant que prestataire intégré de matériaux pour batteries lithium-ion d'énergie nouvelle, Goodenough New Energy peut répondre à vos besoins complets, depuis les besoins de recherche scientifique jusqu'à la production à grande échelle, proposant la configuration d'électrolyte de base, les matières premières d'électrolyte, les électrolytes à fonctionnalités spéciales, ainsi que des services de configuration d'électrolyte en grandes quantités et de personnalisation d'électrolyte.",
    "businessIntroTitle": "Présentation de l'activité",
    "businessItems": [{"title": "Électrolyte"}, {"title": "Réactifs chimiques"}, {"title": "Matériaux de batterie"}, {"title": "Électrolyte à fonctionnalités spéciales"}],
    "caseTabs": [
      {"title":"Gamme riche de produits","description":"A complété le développement de près de 100 types d'additifs fonctionnels pour batteries lithium-ion d'énergie nouvelle, et peut fournir des électrolytes pour lithium/sodium/magnésium/aluminium"},
      {"title":"R-D personnalisée à production en masse","description":"Capacité d'industrialisation de plus de 10 types de matériaux fonctionnels pour batteries lithium-ion, dont la capacité de production prévue pour les produits de la série éthoxyphosphazène atteint le niveau de centaines de tonnes"},
      {"title":"Reconnaissance de collaboration par les entreprises leaders","description":"Les indicateurs des produits ignifuges solides atteignent le niveau international, obtenant la reconnaissance de nombreuses entreprises leaders chinoises dans le domaine de l'énergie nouvelle"}
    ],
    "contactAddress": "Adresse : 8ème étage, 112 Rue Xinqing, Zone Industrielle de Suzhou, Suzhou",
    "contactEmail": "Email : sales022@b2star.com",
    "contactPhone": "Téléphone : 18136447806",
    "contactPostcode": "Code postal : 215121",
    "contactQQ": "QQ : 693755679",
    "contactSubtitle": "Prestataire intégré de matériaux pour batteries lithium-ion d'énergie nouvelle",
    "contactTitle": "Nous contacter",
    "coreBusinessTitle": "Activité principale",
    "enterShop": "En savoir plus",
    "featureTitle": "Caractéristiques du service",
    "pageSubtitle": "Prestataire intégré de matériaux pour batteries lithium-ion d'énergie nouvelle",
    "pageTitle": "Énergie verte",
    "shopSubtitle": "Prestataire intégré de matériaux pour batteries lithium-ion d'énergie nouvelle",
    "shopTitle": "Goodenough New Energy"
  },
  "news": {
    "searchBtn": "Rechercher",
    "noNews": "Aucune nouvelle pertinente",
    "pageTitle": "Centre d'informations",
    "searchPlaceholder": "Veuillez entrer un mot-clé",
    "title": "Actualités de Yacoo",
    "topTag": "Mise en évidence",
    "viewDetail": "En savoir plus",
    "viewMore": "Voir plus"
  },
  "products": {
    "centerTitle": "Centre de produits",
    "screening": "Filtrer par catégorie de produit",
    "detail": {
      "advantages": "Avantages du service",
      "batchInquiry": "Demande de prix pour achat en masse",
      "breadcrumbCenter": "Centre de produits",
      "breadcrumbHome": "Page d'accueil",
      "cas": "CAS : {cas}",
      "customSynthesis": "Consultation sur la synthèse personnalisée",
      "featured": "Produits populaires recommandés",
      "features": "Caractéristiques du produit",
      "getSample": "Obtenir un échantillon",
      "noData": "Aucune donnée disponible",
      "notes": "Remarques",
      "related": "Produits connexes recommandés",
      "researchPurchase": "Achat de recherche scientifique"
    },
    "mainProducts": "Produits principaux",
    "noData": "Aucune donnée disponible",
    "searchBtn": "Rechercher",
    "searchPlaceholder": "Veuillez entrer le nom du produit, le numéro de référence, le numéro CAS ou un mot-clé",
    "panel": {
      "EnglishName": "Nom anglais",
      "Name": "Nom du produit",
      "Alias": "Alias",
      "CAS": "Numéro CAS",
      "UsagePlatform": "Plateforme d'application",
      "ArtNo": "Numéro de référence",
      "molecularFormula": "Formule moléculaire",
      "molecularWeight": "Masse moléculaire",
      "ec": "Numéro EC",
      "enzymeActivity": "Activité enzymatique",
      "activity": "Activité"
    }
  },
  "solution": {
    "learnMore": "En savoir plus",
    "pageSubtitle": "Promouvoir le progrès technique et l'innovation des matériaux médico-chimiques",
    "pageTip": "Yacoo Science se consacre constamment à promouvoir le progrès technique et l'innovation des matériaux médico-chimiques. Sur la base de l'innovation technologique et de l'approvisionnement stable, elle répond aux besoins professionnels des clients, fournit divers produits et services de qualité, pratiques et à bon rapport qualité-prix, promeut le progrès continu de l'industrie des matériaux médico-chimiques et construit ensemble un avenir vert et sain.",
    "pageTitle": "Solutions sectorielles",
    "tableName": "Nom"
  },
  "sustainability": {
    "conceptText": "Yacoo Science adhère constamment à la philosophie de développement durable, intégrant l'innovation verte dans l'ensemble du processus de R-D, de production et d'exploitation. Nous nous engageons à réduire l'empreinte carbone grâce à l'optimisation des procédés écologiques, la réutilisation des ressources et l'application d'énergies renouvelables ; à promouvoir le développement de matériaux biodégradables et de solutions vertes par l'innovation technologique, aidant l'industrie à la transition bas carbone. En même temps, nous exerçons activement notre responsabilité sociale, construisons un système de coexistence et de gagnant-gagnant avec nos employés, les communautés et l'environnement, et nous efforçons d'atteindre un développement coordonné des bénéfices économiques, écologiques et sociaux, contribuant aux objectifs mondiaux de développement durable.",
    "conceptTitle": "Philosophie de développement durable",
    "dataSection": {
      "highConcentrationGas": "Proportion d'énergie verte utilisée",
      "lowConcentrationGas": "Équivalent de dioxyde de carbone par million de yuans",
      "solidWasteStorage": "Dons de livres à l'École Secondaire No. 2 de Kezhou, Xinjiang",
      "wastewaterTreatment": "Dons de bienfaisance sociale en 2024",
      "units": {
        "cubicMeterPerHour": "%",
        "ton": "tonne",
        "tonPerDay": "exemplaire",
        "yuan": "yuan"
      }
    },
    "environmentalProtection": {
      "altText": "Protection de l'environnement",
      "description": "Yacoo Science respecte strictement les lois, règlements et autres dispositions relatives à la protection de l'environnement du pays et des régions locales, et a obtenu la certification du système de management environnemental ISO 14001. Elle dispose de installations complètes de traitement des trois types de déchets (eau usée, gaz polluant, déchet solide), et peut mener des activités de production en toute sécurité tout en garantissant la protection de l'environnement grâce à l'introduction d'installations avancées de traitement des eaux usées, des gaz polluants et des déchets solides.",
      "title": "Protection de l'environnement"
    },
    "greenDevelopment": {
      "buildingAlt": "Bâtiment du siège social de Yacoo Science",
      "description": "En s'appuyant sur l'initiative « Dépasser les frontières médico-chimiques, construire ensemble un avenir vert », Yacoo Science considère le développement vert comme une priorité dans la construction des infrastructures et le développement des produits. Le bâtiment du siège social du groupe a obtenu le certificat de certification LEED (Leadership in Energy and Environmental Design) de niveau Platine délivré par le US Green Building Council, et réalise l'approvisionnement en énergie grâce à des équipements d'énergie verte tels que des panneaux solaires. Les matériaux biologiques de base PEF (polyéthylène furanoate) produits par Yacoo Science à partir de cultures renouvelables peuvent être largement utilisés dans le domaine des bouteilles, réduisant considérablement l'empreinte carbone globale du processus de production des produits.",
      "title": "Développement vert"
    },
    "pageSubtitle": "Service de personnalisation CRO+CDMO pour produits médico-chimiques",
    "pageTitle": "Développement durable",
    "safetyProduction": {
      "certificateAlt": "Certificat de certification environnementale",
      "description": "Yacoo Science a établi un système complet de management de production sûre selon les exigences du système de management de la sécurité et de la santé au travail ISO 45001. Elle protège la ligne de vie de sécurité grâce à des installations informatisées et intelligentes. Par exemple, la base de production de Yacoo à Anqing a obtenu la certification de standardisation de la production sûre de niveau 3, et a construit un système de prévention et de contrôle des risques de sécurité à cinq niveaux intégrant le positionnement des personnes, la visite intelligente, la prévention double, etc.",
      "title": "Production sûre"
    }
  },
  "technology": {
    "achievementsTitle": "Résultats d'innovation",
    "businessIntroText": "Yacoo Science dispose d'un centre de R-D de plus de 10 000 m², équipé d'équipements de pointe tels que la plateforme de synthèse AI et le réacteur à écoulement continu microcanal, et a formé une équipe de R-D de plus de 100 personnes, avec des maîtres et des docteurs comme noyau. Grâce à une coopération approfondie en R-D universitaire-entreprise avec l'Institut de Matériaux de Ningbo de l'Académie Chinoise des Sciences et l'Université de Suzhou, elle a établi des plateformes d'innovation telles que le « Centre de Recherche et Développement Technique Provincial du Jiangsu » et le « Centre d'Innovation Conjoint JITRI-Yacoo », formant un système complet de R-D et de transformation des résultats. Jusqu'à présent, l'entreprise a déposé plus de 150 brevets.",
    "businessIntroTitle": "Système de R-D complet",
    "businessItems": [
      {"title":"Agents de purification biomédicaux et produits chimiques structurels"},
      {"title":"Développement de réactifs de diagnostic in vitro de haute qualité"},
      {"title":"Développement d'enzymes biologiques"},
      {"title":"Développement de matériaux polymères biologiques de haute qualité"},
      {"title":"Produits électroniques de grade semi-conducteur et matériaux pour batteries à énergie nouvelle"}
    ],
    "consultBtn": "Consultation personnalisée",
    "customServiceDesc": "Fondée sur 22 ans d'expérience accumulée dans la R-D de matériaux médico-chimiques, Yacoo Science peut offrir aux clients un service de synthèse personnalisée stable et fiable.",
    "customServiceTitle": "Service de personnalisation du niveau gramme au niveau tonne",
    "leadingProcess": "Procédés de pointe",
    "pageTitle": "La technologie intelligente drive l'avenir créatif",
    "platformList": [
      {"title":"Laboratoire intelligent AI","description":"Le laboratoire de synthèse intelligent AI est équipé d'un instrument de synthèse intelligent AI qui peut définir personnalisément les étapes et paramètres de réaction, surveiller en temps réel le processus de réaction, réaliser le tri rapide des conditions de procédé et la prédiction des meilleures conditions de réaction, améliorant l'efficacité de R-D."},
      {"title":"Laboratoire de purification de réactifs de haute qualité","description":"Utilisé pour la purification de produits chimiques de grade excipient pharmaceutique et de matériaux électroniques de grade semi-conducteur. Le laboratoire est équipé d'équipements de purification avancés, capable de réaliser des expériences de techniques de purification par distillation et filtration membranaire pour des composés tels que les acides, les alcools, les amines et les nitriles."},
      {"title":"Plateforme de laboratoire dédiée à l'électrolyte pour énergie nouvelle","description":"La plateforme peut réaliser des expériences sur les ignifuges pour électrolyte et les électrolytes. Équipée d'équipements spécifiques, elle a réussi les travaux de R-D sur les agents ignifuges de la série phosphazène. Elle peut développer en continu des matériaux de batterie liquides et semi-liquides selon la voie technologique des batteries des clients."},
      {"title":"Plateforme de laboratoire de technologie verte de synthèse biologique","description":"La synthèse biologique s'effectue à température et pression ambiantes, avec faible consommation d'énergie, sans besoin de solvants organiques, et réduit ou élimine les sous-produits toxiques. Cette plateforme développe actuellement des produits tampons biologiques par catalyse enzymatique, de nouveaux substrats de diagnostic et des matériaux de polyestère polymère."},
      {"title":"Plateforme de laboratoire de synthèse chimique","description":"Outre les équipements de synthèse traditionnels, le laboratoire de synthèse chimique est équipé de résonance magnétique nucléaire (RMN), de spectrométrie de masse (MS), de chromatographie liquide à haute performance (HPLC), de station de synthèse automatisée à écoulement continu microcanal et de système de management des données de laboratoire (LIMS). Il peut réaliser le développement d'excipients pharmaceutiques, de substrats de diagnostic et de matériaux composites polymères, y compris le développement personnalisé selon les clients."}
    ],
    "platformTitle": "Cinq plateformes de R-D intelligentes",
    "serviceIcons": ["Agents de purification biomédicaux et produits chimiques structurels","Développement de réactifs de diagnostic in vitro de haute qualité","Développement d'enzymes biologiques","Développement de matériaux polymères biologiques de haute qualité","Produits électroniques de grade semi-conducteur et matériaux pour batteries à énergie nouvelle"],
    "starProduct": "Produits innovants"
  },
  "footer": {
    "contact": {
      "phone": "Téléphone",
      "email": "Email"
    },
    "qrCode": {
      "scanToFollow": "Scanner pour nous suivre"
    },
    "socialMedia": {
      "wechat": "WeChat",
      "tiktok": "TikTok",
      "xiaohongshu": "Xiaohongshu"
    },
    "copyright": "© 2025 Suzhou Yacoo Technology Co., Ltd.",
    "icp": "ICP Jiangsu : 15045967"
  },
  "croCdmoDialog": {
    "logoAlt": "Logo Yacoo",
    "hotline": "Ligne de service gratuite :",
    "description": "Veuillez laisser vos informations de besoins, nous vous contacterons dans un délai de 1 jour ouvrable",
    "form": {
      "name": "Nom",
      "namePlaceholder": "Veuillez entrer votre nom",
      "contact": "Coordonnées",
      "contactPlaceholder": "Veuillez entrer votre téléphone/numéro de mobile/email",
      "company": "Nom de l'entreprise",
      "companyPlaceholder": "Veuillez entrer le nom de votre entreprise",
      "product": "Nom du produit",
      "productPlaceholder": "Veuillez entrer le nom du produit",
      "cas": "Numéro CAS",
      "casPlaceholder": "Veuillez entrer le numéro CAS",
      "requirement": "Besoins d'achat",
      "requirementPlaceholder": "Veuillez entrer vos besoins d'achat",
      "attachment": "Pièce jointe",
      "submit": "Soumettre"
    },
    "upload": {
      "clickToUpload": "Cliquez pour télécharger la pièce jointe",
      "fileFormat": "Formats de fichier : jpg, pdf, doc, taille max 5 Mo",
      "fileSizeError": "La taille du fichier ne peut pas dépasser 5 Mo",
      "fileTypeError": "Veuillez télécharger un fichier au format jpg, pdf ou doc",
      "uploadSuccess": "Téléchargement du fichier réussi",
      "uploadFailed": "Échec du téléchargement, veuillez réessayer"
    },
    "validation": {
      "nameRequired": "Veuillez entrer votre nom",
      "contactRequired": "Veuillez entrer vos coordonnées",
      "casRequired": "Veuillez entrer le numéro CAS"
    },
    "messages": {
      "submitSuccess": "Soumission réussie",
      "submitFailed": "Échec de la soumission",
      "submitFailedRetry": "Échec de la soumission, veuillez réessayer plus tard"
    }
  },
  "productDialog": {
    "logoAlt": "Logo Yacoo",
    "hotline": "Ligne de service gratuite :",
    "description": "Veuillez laisser vos informations de besoins, nous vous contacterons dans un délai de 1 jour ouvrable",
    "form": {
      "name": "Nom",
      "namePlaceholder": "Veuillez entrer votre nom",
      "contact": "Coordonnées",
      "contactPlaceholder": "Veuillez entrer votre téléphone/numéro de mobile/email",
      "company": "Nom de l'entreprise",
      "companyPlaceholder": "Veuillez entrer le nom de votre entreprise",
      "product": "Nom du produit",
      "productPlaceholder": "Veuillez entrer le nom du produit",
      "cas": "Numéro CAS",
      "casPlaceholder": "Veuillez entrer le numéro CAS",
      "requirement": "Besoins d'achat",
      "requirementPlaceholder": "Veuillez entrer vos besoins d'achat",
      "submit": "Soumettre"
    },
    "validation": {
      "nameRequired": "Veuillez entrer votre nom",
      "contactRequired": "Veuillez entrer vos coordonnées",
      "casRequired": "Veuillez entrer le numéro CAS"
    },
    "messages": {
      "submitSuccess": "Soumission réussie",
      "submitFailed": "Échec de la soumission",
      "submitFailedRetry": "Échec de la soumission, veuillez réessayer plus tard"
    }
  },
  "serviceDialog": {
    "logoAlt": "Logo Yacoo",
    "hotline": "Ligne de service gratuite :",
    "description": "Veuillez laisser vos informations de besoins, nous vous contacterons dans un délai de 1 jour ouvrable",
    "form": {
      "name": "Nom",
      "namePlaceholder": "Veuillez entrer votre nom",
      "contact": "Coordonnées",
      "contactPlaceholder": "Veuillez entrer votre téléphone/numéro de mobile/email",
      "company": "Nom de l'entreprise",
      "companyPlaceholder": "Veuillez entrer le nom de votre entreprise",
      "service": "Nom du service",
      "servicePlaceholder": "Veuillez entrer le nom du service",
      "requirement": "Détails des besoins",
      "requirementPlaceholder": "Veuillez entrer vos besoins personnalisés",
      "submit": "Soumettre"
    },
    "validation": {
      "nameRequired": "Veuillez entrer votre nom",
      "contactRequired": "Veuillez entrer vos coordonnées"
    },
    "messages": {
      "submitSuccess": "Soumission réussie",
      "submitFailed": "Échec de la soumission",
      "submitFailedRetry": "Échec de la soumission, veuillez réessayer plus tard"
    }
  },
  "productDownloadDialog": {
    "logoAlt": "Logo Yacoo",
    "title": "Informations de téléchargement du document",
    "description": "Veuillez remplir les informations suivantes pour télécharger le document",
    "form": {
      "companyName": "Nom de l'entreprise",
      "companyNamePlaceholder": "Veuillez entrer le nom de l'entreprise",
      "email": "Email",
      "emailPlaceholder": "Veuillez entrer l'email",
      "mobile": "Téléphone",
      "mobilePlaceholder": "Veuillez entrer le numéro de téléphone",
      "qq": "QQ",
      "qqPlaceholder": "Veuillez entrer QQ (optionnel)",
      "wechat": "WeChat",
      "wechatPlaceholder": "Veuillez entrer WeChat (optionnel)",
      "submit": "Soumettre"
    },
    "validation": {
      "companyNameRequired": "Veuillez entrer le nom de l'entreprise",
      "emailRequired": "Veuillez entrer l'email",
      "emailInvalid": "Veuillez entrer une adresse email valide",
      "mobileRequired": "Veuillez entrer le numéro de téléphone"
    },
    "messages": {
      "submitFailed": "Échec de la soumission",
      "submitFailedRetry": "Échec de la soumission, veuillez réessayer plus tard"
    }
  },
  "purchaseDialog": {
    "logoAlt": "Logo Yacoo",
    "title": "Plus de produits de marques, disponibles sur Element Mall",
    "gotoStore": "Aller au mall pour consulter",
    "storeInfo": "Service fourni par Element Mall, filiale du groupe Yacoo"
  },
  "purchaseListDialog": {
    "logoAlt": "Logo Yacoo",
    "productInfo": "Informations sur le produit",
    "unitPrice": "Prix unitaire (TTC)",
    "more": "Plus",
    "productCode": "Numéro de produit :",
    "itemNumber": "Numéro de référence :",
    "specification": "Spécifications :",
    "parameter": "Paramètres :",
    "contactSales": "Contacter le commercial pour demander un prix",
    "gotoShop": "Aller au mall pour consulter",
    "storeInfo": "Service fourni par Element Mall, filiale du groupe Yacoo"
  },
  "resumeDialog":{
    "logoAlt": "Yacoo",
    "upload": {
      "clickToUpload": "Cliquez pour télécharger votre CV",
      "fileFormat": "Formats de fichier : jpg, pdf, ppt, taille max 5 Mo",
      "fileSizeError": "La taille du fichier ne peut pas dépasser 5 Mo",
      "fileTypeError": "Veuillez télécharger un fichier au format jpg, pdf ou ppt"
    },
    "fileInfo": {
      "removeFile": "Supprimer le fichier"
    },
    "submit": "Envoyer",
    "messages": {
      "uploadSuccess": "Téléchargement du CV réussi",
      "uploadFailed": "Échec du téléchargement, veuillez réessayer",
      "jobNotExist": "Les informations sur le poste n'existent pas",
      "pleaseUploadFirst": "Veuillez d'abord télécharger votre CV"
    }
  },
  "goodChart": {
    "logoAlt": "Logo Yacoo",
    "companyName": "Yacoo Science",
    "consultationPhone": "Téléphone de consultation :",
    "productService": "Consultation sur les produits et service après-vente :",
    "contactEmail": "Email de contact :",
    "leaveMessage": "Laisser un message"
  },
  "searchPage": {
    "pageTitle": "Recherche sur l'ensemble du site",
    "searchInfo": "Recherche : {keyword}",
    "loading": "Chargement en cours...",
    "noData": "Aucune donnée disponible",
    "noNews": "Aucune nouvelle pertinente",
    "noProducts": "Aucun produit pertinent",
    "productInfo": {
      "casNo": "Numéro CAS :",
      "itemNumber": "Numéro de référence :",
      "specification": "Spécifications :",
      "parameter": "Paramètres :",
      "price": "Prix :",
      "unit": "Unité :",
      "inquiry": "Consultation",
      "chemicalName": "Nom chimique"
    },
    "newsInfo": {
      "typeTag": "Étiquette de type"
    },
    "pagination": {
      "prev": "Page précédente",
      "next": "Page suivante"
    }
  }
};
